"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinoBrowserRuntimeTransport = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _constants = require("../../constants");
var _loggerEventEmitter = require("../loggerEventEmitter");
var _canRunLogHandler = require("./canRunLogHandler");
var _filterPinoMessage = require("./filterPinoMessage");
var _getEnabledLogHandlersForTransport = require("./getEnabledLogHandlersForTransport");
const pinoBrowserRuntimeTransport = options => {
  let {
    loggerConfiguration
  } = options;
  let enabledLogHandlers = (0, _getEnabledLogHandlersForTransport.getEnabledLogHandlersForTransport)(options);

  // When settings in browser change we can just reinitialize transports during runtime
  _loggerEventEmitter.loggerEventEmitter.addListener('configurationUpdated', updatedLoggerConfiguration => {
    loggerConfiguration = (0, _deepmerge.default)(_constants.defaultLoggerConfiguration, updatedLoggerConfiguration);
    enabledLogHandlers = (0, _getEnabledLogHandlersForTransport.getEnabledLogHandlersForTransport)({
      ...options,
      loggerConfiguration
    });
  });
  return pinoMessage => {
    // Run all enabled log handlers
    for (const [transportType, logHandler] of enabledLogHandlers) {
      const shouldSkip = !(0, _canRunLogHandler.canRunLogHandler)({
        loggerConfiguration,
        pinoMessage,
        transportType
      });
      if (shouldSkip) {
        continue;
      }
      logHandler((0, _filterPinoMessage.filterPinoMessage)(pinoMessage));
    }
  };
};
exports.pinoBrowserRuntimeTransport = pinoBrowserRuntimeTransport;
//# sourceMappingURL=pinoBrowserRuntimeTransport.js.map